import React, {FC, useEffect, useState} from "react";
import Typography from "@material-ui/core/Typography";
import {Button, Card, CardActions, CardContent, Grid, MenuItem, Select} from "@material-ui/core";
import { useTask } from '../stateManagement/context';
import {
    IControlMeasure,
    IControlType,
} from "../types/types";


interface IControlTypeProps {
    control_types:IControlType[],
    initial_selection_id: string
    control_measure: IControlMeasure,
    updateControlMeasure: (controlMeasure: IControlMeasure) => void
}



const ControlTypeSelection: FC<IControlTypeProps> = ({control_types,
                                                         initial_selection_id,
                                                         control_measure,
                                                         updateControlMeasure }: IControlTypeProps) => {

    let tasks = useTask()

    const [write_access, setWriteAccess] = useState<boolean>(false);


    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])     

    useEffect(() => {
        if (selected === initial_selection_id) {
            return
        }
        setSelected(initial_selection_id)
    }, [initial_selection_id])

    const  [selected, setSelected] = useState(initial_selection_id);

    return (
        <div>
            <Select
                value={selected}
                style={{fontSize:"11pt"}}
                disabled={!write_access}
                onChange={(event) => {
                    let selection = event.target.value
                    let selected_id = control_types.find( (f) => f.id === selection)

                    if (selected_id) {
                        if (selected_id.id) {

                                let c = {...control_measure}
                                c.control_type_id = selected_id.id

                                updateControlMeasure(c)
                        }
                    }
                    setSelected(event.target.value as string)
                }
                } >
                {control_types.map((d) => {

                    return <MenuItem value={d.id}>{d.name}</MenuItem>
                })}
            </Select>
        </div>
    );
}

export default ControlTypeSelection;
